import DialogContent, {
  dialogContentClasses,
  DialogContentProps,
} from '@mui/material/DialogContent';
import DialogTitle, {
  dialogTitleClasses,
  DialogTitleProps,
} from '@mui/material/DialogTitle';
import IconButton, {
  iconButtonClasses,
  IconButtonProps,
} from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const StyledDialogContent = styled(DialogContent)<DialogContentProps>(
  ({ theme }) => ({
    [`&.${dialogContentClasses.root}`]: {
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
  }),
);

export const StyledDialogTitle = styled(DialogTitle)<DialogTitleProps>(
  ({ theme }) => ({
    [`&.${dialogTitleClasses.root}`]: {
      padding: theme.spacing(1.5, 3),
    },
  }),
);

export const StyledIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme }) => ({
    [`&.${iconButtonClasses.root}`]: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  }),
);
